import { useState, useEffect } from 'react'

export function useFetchImage(resolver: () => Promise<string>) {
  const [image, setImage] = useState<string>()
  const [counter, setCounter] = useState(0)

  useEffect(() => {
    async function loadImage() {
      try {
        const image = await resolver()

        setImage(image)
      } catch (err) {
        setImage(undefined)
      }
    }

    loadImage()
  }, [resolver, counter])

  return {
    image,
    refresh: () => setCounter(counter + 1),
  }
}
